import { Box } from '@chakra-ui/react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Loader from '../loader/Loader';

import { BiQuestionMark } from 'react-icons/bi';

interface Props {
    src?: string;
    isLoading: boolean;
}

export default function ProfileAvatar({
    src,
    isLoading,
    ...props
}: Props) {
    return (
        <Box
            background="#222222"
            height="152px"
            width="152px"
            borderColor="#2f3138"
            borderWidth="1px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            {...props}>
            {src && (
                <LazyLoadImage
                    style={{ height: '152px', objectFit: 'cover' }}
                    src={src}
                    height="100%"
                    effect="blur"
                />
            )}
            {isLoading && <Loader />}

            {!isLoading && !src && <BiQuestionMark size="100px" />}
        </Box>
    );
}
